 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import E9781429936354_COV01 from '@/components/e9781429936354_cov01'
 import E9781429936354_TP01 from '@/components/e9781429936354_tp01'
 import E9781429936354_TOC01 from '@/components/e9781429936354_toc01'
 import E9781429936354_DED01 from '@/components/e9781429936354_ded01'
 import E9781429936354_FM01 from '@/components/e9781429936354_fm01'
 import E9781429936354_C01 from '@/components/e9781429936354_c01'
 import E9781429936354_C02 from '@/components/e9781429936354_c02'
 import E9781429936354_C03 from '@/components/e9781429936354_c03'
 import E9781429936354_C04 from '@/components/e9781429936354_c04'
 import E9781429936354_C05 from '@/components/e9781429936354_c05'
 import E9781429936354_C06 from '@/components/e9781429936354_c06'
 import E9781429936354_C07 from '@/components/e9781429936354_c07'
 import E9781429936354_C08 from '@/components/e9781429936354_c08'
 import E9781429936354_C09 from '@/components/e9781429936354_c09'
 import E9781429936354_C10 from '@/components/e9781429936354_c10'
 import E9781429936354_C11 from '@/components/e9781429936354_c11'
 import E9781429936354_C12 from '@/components/e9781429936354_c12'
 import E9781429936354_C13 from '@/components/e9781429936354_c13'
 import E9781429936354_C14 from '@/components/e9781429936354_c14'
 import E9781429936354_C15 from '@/components/e9781429936354_c15'
 import E9781429936354_C16 from '@/components/e9781429936354_c16'
 import E9781429936354_C17 from '@/components/e9781429936354_c17'
 import E9781429936354_C18 from '@/components/e9781429936354_c18'
 import E9781429936354_C19 from '@/components/e9781429936354_c19'
 import E9781429936354_C20 from '@/components/e9781429936354_c20'
 import E9781429936354_C21 from '@/components/e9781429936354_c21'
 import E9781429936354_C22 from '@/components/e9781429936354_c22'
 import E9781429936354_C23 from '@/components/e9781429936354_c23'
 import E9781429936354_C24 from '@/components/e9781429936354_c24'
 import E9781429936354_C25 from '@/components/e9781429936354_c25'
 import E9781429936354_C26 from '@/components/e9781429936354_c26'
 import E9781429936354_C27 from '@/components/e9781429936354_c27'
 import E9781429936354_C28 from '@/components/e9781429936354_c28'
 import E9781429936354_C29 from '@/components/e9781429936354_c29'
 import E9781429936354_C30 from '@/components/e9781429936354_c30'
 import E9781429936354_C31 from '@/components/e9781429936354_c31'
 import E9781429936354_C32 from '@/components/e9781429936354_c32'
 import E9781429936354_C33 from '@/components/e9781429936354_c33'
 import E9781429936354_C34 from '@/components/e9781429936354_c34'
 import E9781429936354_C35 from '@/components/e9781429936354_c35'
 import E9781429936354_C36 from '@/components/e9781429936354_c36'
 import E9781429936354_C37 from '@/components/e9781429936354_c37'
 import E9781429936354_C38 from '@/components/e9781429936354_c38'
 import E9781429936354_C39 from '@/components/e9781429936354_c39'
 import E9781429936354_C40 from '@/components/e9781429936354_c40'
 import E9781429936354_C41 from '@/components/e9781429936354_c41'
 import E9781429936354_C42 from '@/components/e9781429936354_c42'
 import E9781429936354_C43 from '@/components/e9781429936354_c43'
 import E9781429936354_C44 from '@/components/e9781429936354_c44'
 import E9781429936354_C45 from '@/components/e9781429936354_c45'
 import E9781429936354_C46 from '@/components/e9781429936354_c46'
 import E9781429936354_C47 from '@/components/e9781429936354_c47'
 import E9781429936354_C48 from '@/components/e9781429936354_c48'
 import E9781429936354_C49 from '@/components/e9781429936354_c49'
 import E9781429936354_C50 from '@/components/e9781429936354_c50'
 import E9781429936354_C51 from '@/components/e9781429936354_c51'
 import E9781429936354_C52 from '@/components/e9781429936354_c52'
 import E9781429936354_C53 from '@/components/e9781429936354_c53'
 import E9781429936354_C54 from '@/components/e9781429936354_c54'
 import E9781429936354_C55 from '@/components/e9781429936354_c55'
 import E9781429936354_C56 from '@/components/e9781429936354_c56'
 import E9781429936354_C57 from '@/components/e9781429936354_c57'
 import E9781429936354_C58 from '@/components/e9781429936354_c58'
 import E9781429936354_ACK01 from '@/components/e9781429936354_ack01'
 import E9781429936354_ALS01 from '@/components/e9781429936354_als01'
 import E9781429936354_COP01 from '@/components/e9781429936354_cop01'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/e9781429936354_toc01",
 			"name" : "e9781429936354_toc01",
 			"component" : E9781429936354_TOC01
 		},
 		{
 			"path" : "/e9781429936354_ded01",
 			"name" : "e9781429936354_ded01",
 			"component" : E9781429936354_DED01
 		},
 		{
 			"path" : "/e9781429936354_fm01",
 			"name" : "e9781429936354_fm01",
 			"component" : E9781429936354_FM01
 		},
 		{
 			"path" : "/e9781429936354_c01",
 			"name" : "e9781429936354_c01",
 			"component" : E9781429936354_C01
 		},
 		{
 			"path" : "/e9781429936354_c02",
 			"name" : "e9781429936354_c02",
 			"component" : E9781429936354_C02
 		},
 		{
 			"path" : "/e9781429936354_c03",
 			"name" : "e9781429936354_c03",
 			"component" : E9781429936354_C03
 		},
 		{
 			"path" : "/e9781429936354_c04",
 			"name" : "e9781429936354_c04",
 			"component" : E9781429936354_C04
 		},
 		{
 			"path" : "/e9781429936354_c05",
 			"name" : "e9781429936354_c05",
 			"component" : E9781429936354_C05
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js